// extracted by mini-css-extract-plugin
export default {"sgst":"item_sgst__-K3NC"};